import { render, staticRenderFns } from "./AvatarGroupSize.vue?vue&type=template&id=18906c92"
import script from "./AvatarGroupSize.vue?vue&type=script&lang=js"
export * from "./AvatarGroupSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports